import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface SetBalancePayload {
  userId: string;
  leaveType: string;
  allocated: number;
  notes?: string;
}
export interface ZeroBalancePayload {
  userId: string;
  leaveType: string;
  notes?: string;
}

export const useSetBalanceRow = () =>
  useMutation<any, AxiosError, SetBalancePayload>(
    async (payload) => {
      const { data } = await customAxios.patch<{ success: boolean; data: unknown }>(
        "/reports/leaves/balance/row/set",
        payload
      );
      return data;
    },
    {
      onSuccess: () =>
        showNotification({ title: "Balance updated", message: "Saved.", color: "green" }),
      onError: (error) =>
        showNotification({
          title: "Update failed",
          message: (error?.response?.data as any)?.message || "Could not update balance.",
          color: "red",
        }),
    }
  );

export const useZeroBalanceRow = () =>
  useMutation<any, AxiosError, ZeroBalancePayload>(
    async (payload) => {
      const { data } = await customAxios.patch<{ success: boolean; data: unknown }>(
        "/reports/leaves/balance/row/zero",
        payload
      );
      return data;
    },
    {
      onSuccess: () =>
        showNotification({ title: "Balance cleared", message: "Bucket zeroed.", color: "green" }),
      onError: (error) =>
        showNotification({
          title: "Action failed",
          message: (error?.response?.data as any)?.message || "Could not clear balance.",
          color: "red",
        }),
    }
  );
